module.exports = __webpack_public_path__ + "img/Number=106.d12f6ed0.png";